
import { useUserStore } from "@/store/user";
import { defineComponent } from "vue";
import { mapCountry } from "./map_country";

export default defineComponent({
  emits: {
    toggleBillingInfoChangeBlock: null,
  },
  setup() {
    const user = useUserStore();
    return {
      mapCountry,
      user,
    };
  },
});
